import React, {Component} from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import FilterFixedInput from '../../components/filter_fixed_input';
import { Button, Row, Select, message } from 'antd';
import { showErrorInNotification } from '../../lib/util';


class CleanReprocessSetting extends Component {
    constructor(props) {
        super(props)


       
        this.state = {
            repo_id: undefined
        };

          this.list_repositories = RESTExecutor.list().config({
            label: 'list',
            params: {
                
            }

          }).connect(props.domains.datarepository);


        this.clean_repo = RESTExecutor.post().config({
            label: 'clean_repository'
        }).callbacks((success) => {
      message.success(success.result.message || "Cleaning Repository");

           

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.settings);


        this.reprocess_repo = RESTExecutor.post().config({
            label: 'reprocess_repository'
        }).callbacks((success) => {
      message.success(success.result.message || "Cleaning Repository");

           

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.settings);


    }

    


    render() {
        let list_repo_resp = this.list_repositories.response();

        let prepareRepoList = list_repo_resp?.result?.rows?.map(r => ({id: r?.id, label: r?.name}))

        let d = prepareRepoList?.unshift({id: null, label: "All"}) 

      


        return (
            <div style={{padding: "20px"}}>

                <FilterFixedInput
              label="Repositories">
              <Select
                placeholder="Select Repository"
                style={{
                  // width: 300,margin:4
                }}
                value={this.state?.repo_id}
                className=""
                onChange={(value) => {
                    console.log('onchange value', value)

                    this.setState({repo_id: value})
                  }}
                allowClear
              >
                {prepareRepoList?.map((r) => {
                  return <Select.Option key={r?.id} value={r?.id}>
                    {r?.label}
                  </Select.Option>
                })}

              </Select>
            </FilterFixedInput>

            <Row type='flex' style={{ marginTop: 16, gap: "9px" }} >
            <Button  disabled={this.state.repo_id === undefined} type='danger' onClick={() => {
                            this.clean_repo.config({
                                params: {
                                    repository_id: this.state.repo_id
                                }
                            }).execute()
                        }}>Wipe</Button>

<Button
disabled={this.state.repo_id === undefined}
type='primary' onClick={() => {
     this.reprocess_repo.config({
        params: {
            repository_id: this.state.repo_id
        }
    }).execute()                        }}>Reprocess Repositories</Button>
                </Row>
                    
          
            </div>
        );
    }

    componentDidMount(){
        this.setState({
            // filter_query: {
            //     per_page: 100,
            //     page: 1,
            //     ...new_filter_query
            // }
        }, () => {
            this.list_repositories.config({
                // params: {
                //     ...this.state.filter_query
                // }
            }).execute()
        })
    }


}

export default withDomains(CleanReprocessSetting,"settings", "datarepository");
